import { BaseEntity } from 'src/app/core/domain/base.entity';
import { SimNao } from '../simNao/sim-nao';

export class FormaConcessao extends BaseEntity {
  descricao: string;
  exigeContaCorrente: SimNao;
}
